<h2 class="page-heading">CTR Operations</h2>

<div>
    <div fxLayout.xs="row" fxLayoutGap="10px" fxLayoutAlign="center">
        <span class="page-text">Contact Id: </span>
        <app-input-clear [(value)]="contactIdSearch"></app-input-clear>
        <button mat-raised-button class="small" color="primary" (click)="searchContactRecord(contactIdSearch)">Submit</button>
    </div>
    
    <div class="page-text centerMe">OR</div>
    
    <span fxLayout.xs="row" fxLayoutGap="10px" fxLayoutAlign="center">
        <button mat-raised-button color="primary" (click)="uploader.click();">Open File</button>
        <input hidden type="file" (change)="uploadFile($event)" #uploader/>
    </span>
</div>

<div class="vertical-margin">
    <app-response-text [lambdaMessage]="lambdaMessage" [lambdaError]="lambdaError"></app-response-text>
    <span fxLayout.xs="row" fxLayoutAlign="center">
        <progress *ngIf="showProgressBar" [value]="reprocessSuccessCount" [max]="numberOfRecords"></progress>
    </span>
</div>

<div class="table-container vertical-margin" *ngIf="showTable">
    <!--grid-->
    <app-data-grid
    [(data)]="filteredData"
    (itemChange)="handleEvent($event);"
    (buttonEvent)="handleButtonEvent($event);"
    [(isValid)]="formValid"
    [headerTemplate]="header"
    [footerTemplate]="footer"
    [viewTemplate]="view"
    [formTemplate]="formView"
    [columnNames]="['', '', 'Contact ID', 'Claim Number', 'Start Time (sec)', 'End Time (sec)', 'Agent Email', 'info']"
    [spacing]="[0.25, 0.25,  3, 1.5, 1, 1, 2, 2, 0.05]"
    [itemsPerPage]="itemsPerPage"
    [allowDelete]="false"
    [allowAdd]="false"
    [allowEdit]="!disableButtons"
    >

    <ng-template #header>
        <div class="filter" fxLayout.xs="row" fxLayoutAlign="space-between center">
            <input type="text" class="small" [(ngModel)]="filterString" (ngModelChange)="applyFilter();" placeholder="Search..."><br>
            <span>error only:</span>
            <app-toggle-switch [(switch)]="errorOnly" (switchChange)="applyFilter();"></app-toggle-switch>
            <!-- <div>
                <div>
                    missing claim:
                    <input type="checkbox">
                </div>
                <div>
                    read error:
                    <input type="checkbox">
                </div>
            </div> -->
        </div>
    </ng-template>

    <ng-template #footer>
        <span class="error" fxLayout.xs="row" fxLayoutAlign="center">{{footerMessage}}</span>
    </ng-template>

    <ng-template #view let-item>
        <td><mat-icon *ngIf="!metadata[item.contactId].readSuccess" (click)="searchContactRecord(item.contactId, true)">refresh</mat-icon></td>
        <td><mat-icon *ngIf="!metadata[item.contactId].readSuccess" (click)="deleteRowInTable(item);">delete</mat-icon></td>
        <td [ngClass]="validationStyle(item)">{{item.contactId}}</td>
        <td [ngClass]="validationStyle(item)">{{getAttribute(item, 'claimID')}}</td>
        <td [ngClass]="validationStyle(item)">{{getAttribute(item, 'startTime')}}</td>
        <td [ngClass]="validationStyle(item)">{{getAttribute(item, 'endTime')}}</td>
        <td [ngClass]="validationStyle(item)">{{getAttribute(item, 'agentUsername')}}</td>
        <td [ngClass]="validationStyle(item)">{{metadata[item.contactId].info}}</td>
    </ng-template>

    <ng-template #formView let-item>
        <td></td>
        <td></td>
        <td>{{item.contactId}}</td>
        <td><input class="small" type="text" (focus)="includeProperty(item.Attributes, 'claimID');" (focusout)="removeEmptyProperties(item);" [(ngModel)]="item.Attributes.claimID" (ngModelChange)="validateItem(item, true);"></td>
        <td><input class="small" type="text" (focus)="includeProperty(item.Attributes, 'startTime');" (focusout)="removeEmptyProperties(item);" [(ngModel)]="item.Attributes.startTime" (ngModelChange)="validateItem(item, true);"></td>
        <td><input class="small" type="text" (focus)="includeProperty(item.Attributes, 'endTime');" (focusout)="removeEmptyProperties(item);" [(ngModel)]="item.Attributes.endTime" (ngModelChange)="validateItem(item, true);"></td>
        <td><input class="small" type="text" (focus)="includeProperty(item.Attributes, 'agentUsername');" (focusout)="removeEmptyProperties(item);" [(ngModel)]="item.Attributes.agentUsername" (ngModelChange)="validateItem(item, true);"></td>
        <td></td>
    </ng-template>

    </app-data-grid>

    <span fxLayout.xs="row" fxLayoutAlign="center">
        <button mat-raised-button color="primary" (click)="cancel()" [disabled]="disableButtons">Cancel</button>
        <button mat-raised-button color="primary" (click)="reprocessContactRecords()" [disabled]="disableButtons || !reprocessAllowed()">Reprocess</button>
    </span>
</div>